module.exports = __webpack_public_path__ + "static/media/wrong_ans_1.463835ff.png";